import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Announcement,
  useAnnouncements,
} from "../../../../../../../contexts/announcement-context/AnnouncementContext";
import "./styles.scss";
// @ts-ignore
import renderHTML from "react-render-html";
import moment from "moment";
import { useAppContext } from "../../../../../../../contexts/app-context/AppContext";
import { PulseLoader } from "react-spinners";
import UserNotification from "../../../../../../../shared/components/Notification/UserNotification";

interface IProps {
  announcement: Announcement;
}

const AnnouncementCardMember = (props: IProps) => {
  const { push } = useHistory();
  const app = useAppContext();
  const [loading, setLoading] = useState(false);
  const { readAnnouncement } = useAnnouncements();

  const getExpiredOn = (date: Date, days: number): Date => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  return (
    <div className="annoucement-card">
      <div className="d-flex">
        <div
          className="dot-mark-as-read"
          style={{ width: "40px", flexShrink: 0, flexGrow: 0 }}
        >
          {!props.announcement.read && <div></div>}
        </div>
        <div className="ann-m-content" style={{ flex: 1 }}>
          <div className="ann-top">
            <div className="ann-title">
              <label>{props.announcement.title}</label>
            </div>
          </div>
          <div className="ann-flex-container">
            <div className="ann-right multi-line-truncate pr-2">
              {renderHTML(
                props.announcement.description
                  .replace(/<[^>]+>/g, "")
                  .replace(/&nbsp;/g, "")
              )}
            </div>
            <div className="ann-left">
              <div>
                <label className="font-weight-bold">
                  {props.announcement.isActive
                    ? "Announced On :"
                    : "Expired On :"}{" "}
                </label>{" "}
                {moment(
                  props.announcement.isActive
                    ? new Date(props.announcement.date?.seconds * 1000)
                    : getExpiredOn(
                        new Date(props.announcement.date?.seconds * 1000),
                        props.announcement.duration
                      )
                ).format("MM/DD/YYYY")}
                <span className="ml-3">
                  {moment(
                    new Date(props.announcement.date?.seconds * 1000)
                  ).format("h:mm A")}
                </span>
              </div>
              <div>
                <label className="font-weight-bold">Announced By : </label>{" "}
                {props.announcement.createdByName}
              </div>
              <div className="d-flex">
                <label className="font-weight-bold mr-2">Attachments : </label>{" "}
                <span className="atach-count">
                  {props.announcement.fileURLs?.length}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m-action text-right mt-3">
        <div
          className="mr-2 d-inline-block text-center"
          style={{ width: "130px" }}
        >
          <PulseLoader size={15} color={"#006699"} loading={loading} />
        </div>
        {!loading && !props.announcement.read && (
          <>
            <div
              className="link-text d-inline-block mr-2"
              onClick={() => {
                setLoading(true);
                readAnnouncement(props.announcement.id, (status) => {
                  if (status) {
                    UserNotification({
                      isSuccess: true,
                      message: "Notice Successfully Marked as Read",
                    });
                  } else {
                    UserNotification({
                      isSuccess: false,
                      message: "Notice Failed to  Mark as Read",
                    });
                  }

                  setLoading(false);
                });
              }}
            >
              Mark as Read
            </div>
          </>
        )}
        <button
          className="app-button"
          onClick={() => {
            app.pushBackURL("/dashboard/announcements");
            push(
              `/dashboard/announcements/announcement/${props.announcement.id}`
            );
          }}
        >
          View
        </button>
      </div>
    </div>
  );
};

export default AnnouncementCardMember;
